var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D_T_1",
    "data-name": "D&T_1",
    transform: "translate(-0.007 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M14.513,6.826V1.391A.526.526,0,0,0,13.99.859H12V.54a.524.524,0,1,0-1.047,0V.859H9.041V.54a.524.524,0,1,0-1.047,0V.859H6.109V.54a.524.524,0,1,0-1.047,0V.859H3.045a.526.526,0,0,0-.524.532V3.943A9.925,9.925,0,0,1,1.359,8.791,6.132,6.132,0,0,1,.2,10.341a.535.535,0,0,0-.158.589.524.524,0,0,0,.493.35H2.522v1.171a.527.527,0,0,0,.524.532H10.87a3.585,3.585,0,0,0,2.509,1.027,3.691,3.691,0,0,0,1.136-7.182ZM3.569,1.923H5.061v.318a.524.524,0,1,0,1.047,0V1.923H7.994v.318a.524.524,0,1,0,1.047,0V1.923h1.912v.318a.524.524,0,1,0,1.047,0V1.923h1.465V3.411h-9.9V1.923ZM1.7,10.217a8.727,8.727,0,0,0,.547-.851,10.046,10.046,0,0,0,.915-2.241,11.923,11.923,0,0,0,.4-2.648h9.9a10.622,10.622,0,0,1-.316,2.175,3.662,3.662,0,0,0-3.385,3.565H1.7ZM3.569,11.28H9.876a3.621,3.621,0,0,0,.233.639H3.569Zm9.81,1.827a2.782,2.782,0,1,1,2.739-2.781A2.764,2.764,0,0,1,13.379,13.107Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M9.727,8.832h1.368v-1.7",
    transform: "translate(2.308 1.817)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e9fc134ae200ee58d1677f31246cdd89.svg";
export { ForwardRef as ReactComponent };